import * as trigger from "./Lotus-Functions";

export function createLotusLedByLight(p, lotus_webcam) {
  var webcam;
  var source;
  var W = 32;
  var H = 64;
  var cameraScale = 1.5;
  var camMin = 70;
  var camMax = 200;
  var colors = [
    [0, 0, 0],
    [16, 23, 36],
    [6, 46, 40],
    [50, 50, 50],
    [79, 79, 79],
    [150, 150, 150],
    [253, 239, 0],
    [253, 239, 0],
    [170, 170, 170],
    [253, 239, 0],
    [253, 239, 0],
    [255, 255, 255],
  ];
  var minPixelations = 40;
  var maxPixelations = 500;
  var ledbylight;
  var logotx, logoty;
  var pixelationList = [];
  class Pixelation {
    constructor() {
      this.size = trigger.chance(0.97) ? 2 : 4;
      this.x = trigger.randomn(W / this.size) * this.size;
      this.y = trigger.randomn(H / this.size) * this.size;
    }
    run(src) {
      let sum = 0;
      for (let x = 0; x < this.size; x++) {
        for (let y = 0; y < this.size; y++) {
          let ind = ((this.y + y) * W + this.x + x) * 4;
          sum += src[ind];
        }
      }
      sum /= this.size * this.size;
      sum = Math.floor(sum);
      for (let x = 0; x < this.size; x++) {
        for (let y = 0; y < this.size; y++) {
          let ind = ((this.y + y) * W + this.x + x) * 4;
          src[ind] = sum;
          src[ind + 1] = sum;
          src[ind + 2] = sum;
        }
      }
    }
  }
  function pixelation_add(count = 1) {
    for (let i = 0; i < count; i++)
      if (pixelationList.length < maxPixelations)
        pixelationList.push(new Pixelation());
  }
  function pixelation_remove(count = 1) {
    for (let i = 0; i < count; i++)
      if (pixelationList.length > minPixelations) {
        pixelationList.splice(trigger.randomn(pixelationList.length), 1);
      }
  }
  function pixelation(src) {
    for (let p of pixelationList) p.run(src);
  }
  function logo(src, tx, ty) {
    for (let x = 0; x < src.width; x++) {
      for (let y = 0; y < src.height; y++) {
        let inds = (y * src.width + x) * 4;
        let indd = ((ty + y) * W + (tx + x)) * 4;
        if (src.pixels[inds] > 0) {
          source.pixels[indd] = 0;
          source.pixels[indd + 1] = 0;
          source.pixels[indd + 2] = 0;
        }
      }
    }
  }
  p.setup = function () {
    if (p.windowWidth > p.windowHeight) {
      H = 48;
      W = 96;
      minPixelations *= 2;
      maxPixelations *= 2;
      cameraScale = 2.6;
      ledbylight = p.loadImage(
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAAAKCAMAAAAdMYl0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3BpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDkuMS1jMDAxIDc5LmE4ZDQ3NTM0OSwgMjAyMy8wMy8yMy0xMzowNTo0NSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpFOTE2NjQwNDBBRDMxMUVFQjQ5ODg2M0E2OTc5OUU3NyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoxNzFENEFCNjJGMTcxMUVFQjA5QkRGRDc0Mzk3NjU5OCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoxNzFENEFCNTJGMTcxMUVFQjA5QkRGRDc0Mzk3NjU5OCIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgMjQuNiAoTWFjaW50b3NoKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjQxNGUyYTgxLWM1OTUtNGM2OC1hM2Q3LWI3YjQzMjg3ZmZkMCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpEOEU4MDYwODJGMTQxMUVFQjA5QkRGRDc0Mzk3NjU5OCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PkMHPbQAAAAGUExURf3vAP///6ZRxRQAAAACdFJOU/8A5bcwSgAAAFhJREFUeNq8klEKACAIQ+f9Lx0oMh3WnwkxiXpjIgDzgleoGe9C42RP1RfIWoVStb9Bqz1tHL0Kzfj1o6ImQ8b+Bb3Hf0F1QJvQHmBaqQ7lmKalW4MeAQYARlcB9R/8VlEAAAAASUVORK5CYII=",
        () => {
          ledbylight.loadPixels();
          logotx = Math.floor((W - ledbylight.width) / 2);
          logoty = H - ledbylight.height - 4;
        }
      );
    } else {
      ledbylight = p.loadImage(
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAMCAMAAABRJ730AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3BpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDkuMS1jMDAxIDc5LmE4ZDQ3NTM0OSwgMjAyMy8wMy8yMy0xMzowNTo0NSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpFOTE2NjQwNDBBRDMxMUVFQjQ5ODg2M0E2OTc5OUU3NyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1RTVGNjRFRDJGMTYxMUVFQjA5QkRGRDc0Mzk3NjU5OCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1RTVGNjRFQzJGMTYxMUVFQjA5QkRGRDc0Mzk3NjU5OCIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgMjQuNiAoTWFjaW50b3NoKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjgzMTBmOWFiLWZiYmYtNDM3ZC04ZmJhLWVhZTZkNWM0MmFkMyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpFOTE2NjQwNDBBRDMxMUVFQjQ5ODg2M0E2OTc5OUU3NyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PkkKykIAAAAGUExURf3vAP///6ZRxRQAAAACdFJOU/8A5bcwSgAAAEdJREFUeNp0jgkKACAIBGf//+lK7bBMEGUYVkES0FuytbeBMW1XjIVh4VAK23Xu7Km89ceRHq/5F1QHE2abySbbcGYbbgIMAGAPALQoD/oIAAAAAElFTkSuQmCC",
        () => {
          ledbylight.loadPixels();
          logotx = Math.floor((W - ledbylight.width) / 2);
          logoty = H - ledbylight.height - 4;
        }
      );
    }
    p.createCanvas(W, H);
    p.pixelDensity(1);
    webcam = lotus_webcam.source;
    source = p.createGraphics(W, H);
    source.pixelDensity(1);
    source.hide();
    source.imageMode(p.CENTER);
    source.translate(W / 2, H / 2);
    source.scale(-cameraScale, cameraScale);
    pixelation_add(minPixelations);
  };
  p.draw = function () {
    if (webcam === undefined) return;
    source.image(webcam, 0, 0, (H * webcam.width) / webcam.height, H);
    source.loadPixels();
    trigger.greyscale(source.pixels, camMin, camMax);
    pixelation_remove(4);
    if (p.frameCount % 12 == 0) {
      let count = trigger.fmap(p.noise(p.frameCount * 0.02), 0.55, 0.9, 0, 500);
      pixelation_add(count);
    }
    if (trigger.chance(0.005)) pixelation_add(600);
    pixelation(source.pixels);
    trigger.gradientMap(source.pixels, colors);
    logo(ledbylight, logotx, logoty);
    source.updatePixels();
    p.image(source, 0, 0);
  };
}
